// Menu Store - AgentBheem ERP
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface MenuStore {
  // State
  isCollapsed: boolean
  isMobileOpen: boolean
  expandedGroupIds: string[]

  // Actions
  toggleCollapse: () => void
  setCollapsed: (collapsed: boolean) => void
  toggleMobile: () => void
  setMobileOpen: (open: boolean) => void
  toggleGroup: (groupId: string) => void
  expandGroup: (groupId: string) => void
  collapseGroup: (groupId: string) => void
  collapseAllGroups: () => void
}

export const useMenuStore = create<MenuStore>()(
  persist(
    (set) => ({
      // Initial state
      isCollapsed: false,
      isMobileOpen: false,
      expandedGroupIds: [],

      // Toggle sidebar collapse
      toggleCollapse: () =>
        set((state) => ({ isCollapsed: !state.isCollapsed })),

      setCollapsed: (collapsed) => set({ isCollapsed: collapsed }),

      // Toggle mobile drawer
      toggleMobile: () =>
        set((state) => ({ isMobileOpen: !state.isMobileOpen })),

      setMobileOpen: (open) => set({ isMobileOpen: open }),

      // Toggle group expand/collapse
      toggleGroup: (groupId) =>
        set((state) => ({
          expandedGroupIds: state.expandedGroupIds.includes(groupId)
            ? state.expandedGroupIds.filter((id) => id !== groupId)
            : [...state.expandedGroupIds, groupId],
        })),

      expandGroup: (groupId) =>
        set((state) => ({
          expandedGroupIds: state.expandedGroupIds.includes(groupId)
            ? state.expandedGroupIds
            : [...state.expandedGroupIds, groupId],
        })),

      collapseGroup: (groupId) =>
        set((state) => ({
          expandedGroupIds: state.expandedGroupIds.filter((id) => id !== groupId),
        })),

      collapseAllGroups: () => set({ expandedGroupIds: [] }),
    }),
    {
      name: 'bheem-menu-store',
      // Only persist sidebar collapse state, NOT expanded groups
      // Groups should always start collapsed on page refresh
      partialize: (state) => ({
        isCollapsed: state.isCollapsed,
      }),
    }
  )
)
